import { filter } from 'rxjs/operators';
import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Event, RouterOutlet } from '@angular/router';

import { routeAnimations } from '../../core/animations/route.animations';
import { environment } from '@env/environment';

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.scss'],
    animations: [routeAnimations]
})
export class BodyComponent {

    pageHeader = '';
    showPersona = false;
    showHeader = true;
    centerHeader = false;
    useAlternateLayout = false;
    private queryParams: any = {};

    constructor(private route: ActivatedRoute,
        private router: Router) {
        router.events
            .pipe(
                filter(e => e instanceof NavigationEnd)
            )
            .forEach((e: Event) => {
                this.pageHeader = this.getPageHeader(route.root);
                this.pageHeader = !!this.pageHeader ? this.pageHeader : '';
                this.showHeader = this.getShowHeader(route.root) && !this.shouldHideHeaderForReverification(route.root);
                this.showPersona = this.getShowPersona(e);
                this.centerHeader = this.getCenterHeader(e);
            });

        this.route.queryParams.subscribe(params => {
            this.queryParams = params;
            const enableAlternateLayout = environment.enableAlternateLayout ?? false;
            if (enableAlternateLayout) {
                this.useAlternateLayout = params.useAlternateLayout === 'true';
            }
            this.showHeader = this.getShowHeader(this.route.root) && !this.shouldHideHeaderForReverification(this.route.root);
        });
    }

    getPageHeader(route: ActivatedRoute) {
        return (route.firstChild) ? this.getPageHeader(route.firstChild) : route.snapshot.data['pageHeader'];
    }

    getShowHeader(route: ActivatedRoute): boolean {
        return route.firstChild
            ? this.getShowHeader(route.firstChild)
            : route.snapshot.data?.['showHeader'] ?? true;
    }

    private shouldHideHeaderForReverification(route: ActivatedRoute): boolean {
        if (route.firstChild) {
            return this.shouldHideHeaderForReverification(route.firstChild);
        }

        return route.snapshot.data?.['hideHeaderForReverification'] === true &&
            this.queryParams?.reason === 'reverification';
    }

    getAnimationState(o: RouterOutlet) {
        return o.isActivated && (o.activatedRoute.routeConfig.path || o.activatedRouteData['animationData']);
    }

    getShowPersona(event: Event) {
        if (!('url' in event)) {
            return;
        }
        const [, path1, path2] = event.url.split('/');
        const isInLabTest = /lab-tests/.test(path1);
        const isInSupplies = /sampling-supplies|catalogue/.test(path1);
        const isInPersonaSelection = /persona-selection/.test(path2);
        return !!environment['showPersonaOptions'] && !isInPersonaSelection && (isInLabTest || isInSupplies);
    }

    getCenterHeader(event: Event) {
        if (!('url' in event)) {
            return;
        }

        const [, path1, path2] = event.url.split('/');
        const centeredPages = ['login', 'create', 'reset-password', 'set-password', 'change-password'];
        return (path1 === 'account' || path1 === 'profile') && centeredPages.includes(path2);
    }

}
